<div class="trend-indicator">
  @if (hasInsufficientData) {
    <span class="trend-label trend-insufficient">
      {{ trendText | translate }}
    </span>
  } @else {
    <span class="trend-label">
      {{ 'comparedToThePreviousTrendIs' | translate: { timePeriod: getTranslatedPeriodLabel() } }}
      <mat-icon [class]="getTrendIconClass()">
        @if (trend === 'very positive' || trend === 'positive' || trend === 'neutral') {
          trending_up
        } @else if (trend === 'negative' || trend === 'very negative') {
          trending_down
        }
      </mat-icon>
      <span [class]="getTrendClass()">{{ trendText | translate }}</span>
    </span>
  }
</div>
